import { render, staticRenderFns } from "./TaskLog.vue?vue&type=template&id=79c64f2a&scoped=true&"
import script from "./TaskLog.vue?vue&type=script&lang=js&"
export * from "./TaskLog.vue?vue&type=script&lang=js&"
import style0 from "./TaskLog.vue?vue&type=style&index=0&id=79c64f2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c64f2a",
  null
  
)

export default component.exports